import { createContext } from 'react';
import RootStore from '@core/stores/root-store';

export const RootStoreContext = createContext<RootStore>({} as RootStore);
